(function () {
  var ROOT_SELECTOR = '.index-product--partner';
  var SELECTOR_SELECTOR = '[data-partner-variant-selector]';
  var OPTION_WRAPPER_SELECTOR = '[data-option-position]';
  var OPTION_INPUT_SELECTOR = '[data-single-option-selector]';
  var POPOUT_OPTION_SELECTOR = '[data-popout-option]';
  var POPOUT_INPUT_SELECTOR = '[data-popout-input][data-single-option-selector]';
  var PRODUCT_JSON_SELECTOR = '[data-product-json]';
  var INLINE_PURCHASE_SELECTOR = '[data-partner-inline-purchase]';
  var INLINE_ADD_SELECTOR = '.product__partner-add-to-cart[data-add-to-cart]';
  var STICKY_PURCHASE_SELECTOR = '[data-partner-sticky-purchase]';
  var STICKY_ADD_SELECTOR = '[data-partner-sticky-add-to-cart]';
  var FORM_ERRORS_SELECTOR = '[data-cart-errors-container]';
  var UNAVAILABLE_CLASS = 'is-partner-unavailable';
  var SOLD_OUT_CLASS = 'is-partner-sold-out';
  var VISIBLE_CLASS = 'is-visible';
  var LOADING_CLASS = 'is-loading';
  var ADDED_CLASS = 'is-added';
  var MOBILE_MEDIA = '(max-width: 749px)';
  var PREFERRED_INITIAL_SIZE = 'Small';
  var READY_FLAG = '__pmPartnerProductReady';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function parseProductJson(root) {
    var script = root.querySelector(PRODUCT_JSON_SELECTOR) || document.querySelector(PRODUCT_JSON_SELECTOR);
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || script.innerHTML || '{}');
    } catch (error) {
      return null;
    }
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options.map(String);

    return [variant.option1, variant.option2, variant.option3]
      .filter(function (value) {
        return value !== undefined && value !== null;
      })
      .map(String);
  }

  function getOptionPosition(wrapper) {
    return Number.parseInt(wrapper.getAttribute('data-option-position') || '0', 10);
  }

  function getOptionName(option) {
    if (typeof option === 'string') return option;
    return option && option.name ? String(option.name) : '';
  }

  function getSelectedValue(wrapper) {
    var checked = wrapper.querySelector(OPTION_INPUT_SELECTOR + ':checked');
    if (checked && checked.value) return String(checked.value);

    var input = wrapper.querySelector(POPOUT_INPUT_SELECTOR);
    if (input && input.value) return String(input.value);

    var field = wrapper.querySelector(OPTION_INPUT_SELECTOR);
    return field && field.value ? String(field.value) : '';
  }

  function getCandidateValue(candidate) {
    return String(candidate.getAttribute('data-value') || candidate.value || '');
  }

  function variantsMatching(productData, selections) {
    if (!productData || !Array.isArray(productData.variants)) return [];

    return productData.variants.filter(function (variant) {
      var options = getVariantOptions(variant);

      return selections.every(function (selection, index) {
        if (!selection) return true;
        return String(options[index]) === String(selection);
      });
    });
  }

  function hasAvailableVariant(productData, selections) {
    return variantsMatching(productData, selections).some(function (variant) {
      return variant.available;
    });
  }

  function hasAnyVariant(productData, selections) {
    return variantsMatching(productData, selections).length > 0;
  }

  function findFirstAvailableCandidate(productData, wrappers, position) {
    var wrapper = wrappers[position - 1];
    if (!wrapper) return null;

    var candidates = getCandidates(wrapper);
    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      var candidateValue = getCandidateValue(candidate);
      var selections = buildSelections(wrappers, position, candidateValue);

      if (hasAvailableVariant(productData, selections)) {
        return candidate;
      }
    }

    return null;
  }

  function buildSelections(wrappers, position, candidateValue) {
    var selections = [];

    wrappers.forEach(function (wrapper) {
      var wrapperPosition = getOptionPosition(wrapper);
      if (!wrapperPosition || wrapperPosition > position) return;
      selections[wrapperPosition - 1] = wrapperPosition === position ? candidateValue : getSelectedValue(wrapper);
    });

    return selections;
  }

  function getCandidates(wrapper) {
    var popoutOptions = Array.prototype.slice.call(wrapper.querySelectorAll(POPOUT_OPTION_SELECTOR));
    if (popoutOptions.length) return popoutOptions;

    return Array.prototype.slice.call(wrapper.querySelectorAll(OPTION_INPUT_SELECTOR));
  }

  function setCandidateState(candidate, available, possible) {
    var target = candidate.closest('.radio__button, .swatch__button, .select-popout__item') || candidate;
    var isInput = candidate.matches && candidate.matches(OPTION_INPUT_SELECTOR);

    target.classList.toggle(UNAVAILABLE_CLASS, !possible);
    target.classList.toggle(SOLD_OUT_CLASS, possible && !available);
    candidate.classList.toggle(UNAVAILABLE_CLASS, !possible);
    candidate.classList.toggle(SOLD_OUT_CLASS, possible && !available);

    if (isInput) {
      candidate.disabled = !possible;
    } else {
      candidate.setAttribute('aria-disabled', possible ? 'false' : 'true');
      candidate.tabIndex = possible ? 0 : -1;
    }
  }

  function selectCandidate(wrapper, candidate) {
    if (!candidate) return false;

    if (candidate.matches && candidate.matches(OPTION_INPUT_SELECTOR)) {
      if (candidate.checked) return false;
      candidate.checked = true;
      candidate.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    var value = getCandidateValue(candidate);
    var input = wrapper.querySelector(POPOUT_INPUT_SELECTOR);
    var toggleText = wrapper.querySelector('[data-popout-toggle-text]');

    if (!input || input.value === value) return false;

    input.value = value;
    if (toggleText) toggleText.textContent = value;

    wrapper.querySelectorAll('.select-popout__item').forEach(function (item) {
      item.classList.remove('is-active');
    });
    wrapper.querySelectorAll(POPOUT_OPTION_SELECTOR).forEach(function (option) {
      option.removeAttribute('aria-current');
    });

    var activeItem = candidate.closest('.select-popout__item');
    if (activeItem) activeItem.classList.add('is-active');
    candidate.setAttribute('aria-current', 'true');
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function selectInitialPreferredSize(productData, wrappers) {
    if (!productData || !Array.isArray(productData.options) || !Array.isArray(productData.variants)) return false;

    var sizeIndex = productData.options.findIndex(function (option) {
      return getOptionName(option).toLowerCase() === 'size';
    });
    if (sizeIndex < 0) return false;

    var preferredVariant = productData.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      return variant.available && String(options[sizeIndex] || '').toLowerCase() === PREFERRED_INITIAL_SIZE.toLowerCase();
    });
    if (!preferredVariant) return false;

    var preferredOptions = getVariantOptions(preferredVariant);
    var changed = false;

    wrappers.forEach(function (wrapper) {
      var position = getOptionPosition(wrapper);
      var preferredValue = preferredOptions[position - 1];
      if (!position || preferredValue === undefined || getSelectedValue(wrapper) === String(preferredValue)) return;

      var candidate = getCandidates(wrapper).find(function (item) {
        return getCandidateValue(item) === String(preferredValue);
      });
      changed = selectCandidate(wrapper, candidate) || changed;
    });

    return changed;
  }

  function updatePartnerOptions(root, productData) {
    var selector = root.querySelector(SELECTOR_SELECTOR);
    if (!selector || !productData || !Array.isArray(productData.variants)) return;

    var wrappers = Array.prototype.slice.call(selector.querySelectorAll(OPTION_WRAPPER_SELECTOR))
      .sort(function (a, b) {
        return getOptionPosition(a) - getOptionPosition(b);
      });

    wrappers.forEach(function (wrapper) {
      var position = getOptionPosition(wrapper);
      if (!position) return;

      getCandidates(wrapper).forEach(function (candidate) {
        var selections = buildSelections(wrappers, position, getCandidateValue(candidate));
        var possible = hasAnyVariant(productData, selections);
        var available = hasAvailableVariant(productData, selections);
        setCandidateState(candidate, available, possible);
      });
    });

    var changed = false;
    wrappers.forEach(function (wrapper) {
      if (changed) return;

      var position = getOptionPosition(wrapper);
      var selectedValue = getSelectedValue(wrapper);
      if (!position || !selectedValue) return;

      if (!hasAvailableVariant(productData, buildSelections(wrappers, position, selectedValue))) {
        changed = selectCandidate(wrapper, findFirstAvailableCandidate(productData, wrappers, position));
      }
    });

    selector.classList.add('is-partner-variant-ready');
  }

  function initPartnerStickyPurchase(root) {
    var inlinePurchase = root.querySelector(INLINE_PURCHASE_SELECTOR);
    var inlineAdd = root.querySelector(INLINE_ADD_SELECTOR);
    var stickyPurchase = root.querySelector(STICKY_PURCHASE_SELECTOR);
    var stickyAdd = root.querySelector(STICKY_ADD_SELECTOR);
    if (!inlinePurchase || !inlineAdd || !stickyPurchase || !stickyAdd) return;

    var mobileMedia = window.matchMedia(MOBILE_MEDIA);
    var inlineVisible = false;
    var stickyInitiated = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function isScrollLocked() {
      return document.documentElement.hasAttribute('data-scroll-locked');
    }

    function syncStickyState() {
      stickyAdd.disabled = inlineAdd.disabled;
      stickyAdd.classList.toggle(LOADING_CLASS, inlineAdd.classList.contains(LOADING_CLASS));
      stickyAdd.classList.toggle(ADDED_CLASS, inlineAdd.classList.contains(ADDED_CLASS));
    }

    function syncStickyHeight() {
      var height = mobileMedia.matches ? stickyPurchase.offsetHeight : 0;
      document.documentElement.style.setProperty('--partner-sticky-purchase-height', height + 'px');
    }

    function updateVisibility() {
      var visible = mobileMedia.matches && !inlineVisible && !isScrollLocked();
      stickyPurchase.classList.toggle(VISIBLE_CLASS, visible);
      stickyPurchase.setAttribute('aria-hidden', visible ? 'false' : 'true');
      syncStickyHeight();
    }

    function scrollToInlineError() {
      var errors = root.querySelector(FORM_ERRORS_SELECTOR);
      if (!errors || !errors.textContent.trim()) return;

      errors.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'center',
      });
    }

    stickyAdd.addEventListener('click', function (event) {
      event.preventDefault();
      if (stickyAdd.disabled) return;

      stickyInitiated = true;
      stickyAdd.classList.add(LOADING_CLASS);
      inlineAdd.click();
    });

    root.addEventListener('theme:variant:change', function () {
      window.requestAnimationFrame(syncStickyState);
    });

    document.addEventListener('theme:product:add', function (event) {
      if (!event.detail || event.detail.button !== inlineAdd) return;
      window.requestAnimationFrame(syncStickyState);
    });

    document.addEventListener('theme:product:add-error', function (event) {
      if (!event.detail || event.detail.button !== inlineAdd) return;
      window.requestAnimationFrame(syncStickyState);
      if (stickyInitiated) scrollToInlineError();
      stickyInitiated = false;
    });

    document.addEventListener('theme:product:added', function () {
      stickyInitiated = false;
      window.requestAnimationFrame(syncStickyState);
    });

    var inlineObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      inlineVisible = Boolean(entry && entry.isIntersecting && entry.intersectionRatio >= 0.2);
      updateVisibility();
    }, {
      threshold: [0, 0.2, 1],
    });
    inlineObserver.observe(inlinePurchase);

    var buttonObserver = new MutationObserver(syncStickyState);
    buttonObserver.observe(inlineAdd, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
    });

    var lockObserver = new MutationObserver(updateVisibility);
    lockObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-scroll-locked'],
    });

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', updateVisibility);
    } else {
      mobileMedia.addListener(updateVisibility);
    }

    window.addEventListener('resize', syncStickyHeight);
    syncStickyState();
    updateVisibility();
  }

  function initPartnerProduct(root) {
    if (!root || root[READY_FLAG]) return;
    root[READY_FLAG] = true;

    var productData = parseProductJson(root);
    if (!productData) return;
    var initialSelectionPending = true;

    function queueUpdate() {
      window.requestAnimationFrame(function () {
        if (initialSelectionPending) {
          initialSelectionPending = false;
          var selector = root.querySelector(SELECTOR_SELECTOR);
          var wrappers = selector
            ? Array.prototype.slice.call(selector.querySelectorAll(OPTION_WRAPPER_SELECTOR)).sort(function (a, b) {
              return getOptionPosition(a) - getOptionPosition(b);
            })
            : [];
          selectInitialPreferredSize(productData, wrappers);
        }
        updatePartnerOptions(root, productData);
      });
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches(OPTION_INPUT_SELECTOR)) {
        queueUpdate();
      }
    });

    root.addEventListener('click', function (event) {
      var option = event.target && event.target.closest && event.target.closest(POPOUT_OPTION_SELECTOR);
      if (option && option.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (option) queueUpdate();
    }, true);

    root.addEventListener('theme:variant:change', queueUpdate);
    initPartnerStickyPurchase(root);
    queueUpdate();
  }

  ready(function () {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initPartnerProduct);
  });
})();
